import { BookOpen, Coffee, type LucideIcon, Moon, Train } from "lucide-preact";
import { Section, SectionHeading } from "./Section";

type Moment = { icon: LucideIcon; title: string; text: string };

const MOMENTS: Moment[] = [
  { icon: Train, title: "On the way", text: "Earbuds in, press play. The commute just got a lot more interesting." },
  { icon: Coffee, title: "While the kettle boils", text: "One article, one idea. Finished before your tea is ready." },
  { icon: Moon, title: "Before bed", text: "Swap the endless scroll for something you will still remember tomorrow." },
  { icon: BookOpen, title: "On the sofa", text: "Prefer reading? Every article is made to be a pleasure to read, too." },
];

const MomentCard = ({ icon: Icon, title, text }: Moment) => (
  <div class="rounded-2xl bg-white dark:bg-neutral-800 border border-gray-200 dark:border-gray-700 p-6">
    <span class="inline-flex w-11 h-11 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/40 text-purple-600 dark:text-purple-300">
      <Icon class="w-5 h-5" />
    </span>
    <h3 class="mt-4 text-lg font-bold text-gray-900 dark:text-gray-50">{title}</h3>
    <p class="mt-1.5 text-gray-600 dark:text-gray-300">{text}</p>
  </div>
);

export const Moments = () => (
  <Section>
    <SectionHeading title="Made for the gaps in your day" intro="Read or listen whenever a spare moment turns up." />
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {MOMENTS.map((moment) => (
        <MomentCard key={moment.title} {...moment} />
      ))}
    </div>
  </Section>
);
